var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var Lock = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M8.625 9.375V6C8.625 5.10489 8.98058 4.24645 9.61351 3.61351C10.2465 2.98058 11.1049 2.625 12 2.625C12.8951 2.625 13.7535 2.98058 14.3865 3.61351C15.0194 4.24645 15.375 5.10489 15.375 6V9.375M4.5 9.375H19.5C19.9142 9.375 20.25 9.71079 20.25 10.125V20.625C20.25 21.0392 19.9142 21.375 19.5 21.375H4.5C4.08579 21.375 3.75 21.0392 3.75 20.625V10.125C3.75 9.71079 4.08579 9.375 4.5 9.375Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
